import React, { ReactElement } from 'react';
import NumericInput from "./NumericInput";

export type PercentageInputProps = {
    id: string,
    name?: string,
    label: string,
    required: boolean,
    disabled?: boolean,
    labelContent?: ReactElement,
    changeCallback?: Function,
    children?: React.ReactNode
}

const PercentageInput = (props: PercentageInputProps) => {
    return <NumericInput id={props.id} name={props.name} label={props.label} required={props.required} disabled={props.disabled}
                         labelContent={props.labelContent}
                         changeCallback={props.changeCallback}
                         inputMask={{ alias: 'percentage', suffix: '', placeholder: '' }}
                         rightContent={<>%</>}/>
};
export default PercentageInput;